import { useState, useEffect } from 'react';
import parameterSingleton from '../../services/Parameters.service';

const usePuntoAtencionParams = () => {
  const [listPuntoAtencion, setListPuntoAtencion] = useState<any[]>([]);
  const [loadingParams, setLoadingParams] = useState(false);

  const fetchPuntoAtencion = async () => {
    setLoadingParams(true);
    try {
      const data = await parameterSingleton.fetchData('PUNTOATENCION');
      setListPuntoAtencion(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error cargando puntos de atención:', error);
      setListPuntoAtencion([]);
    } finally {
      setLoadingParams(false);
    }
  };

  useEffect(() => {
    fetchPuntoAtencion();
  }, []);

  return { 
    listPuntoAtencion, 
    loadingParams,
    refetchPuntoAtencion: fetchPuntoAtencion // opcional, para re-cargar
  };
};

export default usePuntoAtencionParams;